import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = {
  key: 1,
  class: "refunded"
}
const _hoisted_4 = ["disabled", "onClick"]

import type { Transaction } from '@busy-human/payment-module';
import type { DataInstance } from '@busy-human/gearbox';
import { ref, watch } from 'vue';
import { firestore } from '../util/firebase';
import { type CollectionReference, collection, getDocs, query, where } from 'firebase/firestore';
import { stripeIssueRefund } from '@/util/functions';


export default /*@__PURE__*/_defineComponent({
  __name: 'invoice-transactions',
  props: {
    stripeIds: {}
  },
  setup(__props: any) {

const props = __props;
const loading = ref(false);

const transactions = ref<DataInstance<Transaction.Model>[]>([]);
async function fetchTransactions() {
	if(!props.stripeIds.length) return;
	loading.value = true;
	// TODO: Move this logic to gearbox
	try{

		const col = collection(firestore, "Transactions") as CollectionReference<Transaction.Model>;
		const q = query(col, where("externalIds.stripe", "in", props.stripeIds));
		const docs = await getDocs(q);
		transactions.value = docs.docs.map(d => ({
			... d.data(),
			$id: d.id
		}));
	
	}catch(e){
		console.log("Error", e);
	}
	
	
	loading.value = false;
}

async function refundTransaction(transaction: DataInstance<Transaction.Model>) {
	if(!transaction.externalIds.stripe) return;
	if(transaction.voided) return;
	loading.value = true;
	try {
		await stripeIssueRefund({transactionId: transaction.$id});
		console.log(transaction.externalIds.stripe);
		// TODO: Do something else
		alert("Refunded");
	} catch (e) {
		// TODO: Do something else
		alert((e as Error).message);
	} finally {
		await fetchTransactions();
	}
}

function openStripeLink(transaction: DataInstance<Transaction.Model>) {
	if (process.env.NODE_ENV === 'development') {
		const link = `https://dashboard.stripe.com/test/payments/${transaction.externalIds.stripe}`;
		window.open(link);
	} else {
		const link = `https://dashboard.stripe.com/payments/${transaction.externalIds.stripe}`;
		window.open(link);
	}
}

function estimatedDate(date: string | Date) {
	const tmp = new Date(date);
	const followingDate = new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate() + 2, tmp.getHours(), tmp.getMinutes());
	return followingDate.toLocaleDateString();
}

watch(() => props.stripeIds, async () => {
	await fetchTransactions();
}, {immediate: true, deep: true});


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (t) => {
    return (_openBlock(), _createElementBlock("tr", {
      key: t.$id
    }, [
      _createElementVNode("td", null, _toDisplayString(t.total), 1),
      _createElementVNode("td", null, _toDisplayString(t.initiated ? new Date(t.initiated).toLocaleString() : "Unknown"), 1),
      _createElementVNode("td", null, _toDisplayString(t.initiated ? estimatedDate(t.initiated) : "Unknown"), 1),
      (!t.voided)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createElementVNode("button", {
              class: _normalizeClass(["secondary", {refunded: t.voided}]),
              disabled: t.voided || loading.value,
              onClick: ($event: any) => (refundTransaction(t))
            }, "Refund", 10, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      (t.voided)
        ? (_openBlock(), _createElementBlock("td", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("div", null, "Refunded", -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          class: "secondary",
          disabled: loading.value,
          onClick: ($event: any) => (openStripeLink(t))
        }, "Open in Stripe", 8, _hoisted_4)
      ])
    ]))
  }), 128))
}
}

})